export default __webpack_public_path__ + "static/media/api-management.3d9cdcd6.svg";